export const sportsQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "The court is being used.",
      B: "The basketball court has been marked with lines.",
      C: "The hoops are being installed.",
      D: "Basketballs are stacked in the corner.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 농구 코트에 라인이 그려져 있음\n" +
      "오답 설명: (A) 코트를 사용하는 사람이 없음, (C) 골대는 이미 설치되어 있음, (D) 농구공이 보이지 않음",
  },
  {
    questionNumber: 2,
    choices: {
      A: "The swimming pool is being cleaned.",
      B: "Swimmers are diving into the water.",
      C: "The swimming lanes are clearly marked.",
      D: "A lifeguard is standing by the pool.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 수영장의 레인이 명확하게 표시되어 있음\n" +
      "오답 설명: (A) 수영장을 청소하는 사람이 없음, (B) 다이빙하는 사람이 없음, (D) 구명 요원이 보이지 않음",
  },
  {
    questionNumber: 3,
    choices: {
      A: "Lines are being painted on the court.",
      B: "The net is being set up.",
      C: "The net divides the court into two sections.",
      D: "A scoreboard is mounted on the wall.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 네트가 코트를 두 구역으로 나누고 있음\n" +
      "오답 설명: (A) 라인은 이미 그려져 있음, (B) 네트는 이미 설치되어 있음, (D) 점수판이 보이지 않음",
  },
  {
    questionNumber: 4,
    choices: {
      A: "Some lockers have been opened.",
      B: "Benches are placed in front of the lockers.",
      C: "Clothes are hanging inside the lockers.",
      D: "A sitting area is being set up.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 벤치가 사물함 앞에 놓여있음\n" +
      "오답 설명: (A) 모든 사물함이 닫혀있음, (C) 사물함 안이 보이지 않음, (D) 좌석 공간은 이미 설치되어 있음",
  },
  {
    questionNumber: 5,
    choices: {
      A: "A treadmill is being used.",
      B: "The gym is being cleaned.",
      C: "The workout equipment is arranged in a row.",
      D: "The windows are covered with blinds.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 운동 기구들이 일렬로 배치되어 있음\n" +
      "오답 설명: (A) 트레드밀을 사용하는 사람이 없음, (B) 체육관을 청소하는 사람이 없음, (D) 창문에 블라인드가 없음",
  },
  {
    questionNumber: 6,
    choices: {
      A: "A tennis match is taking place.",
      B: "The stands are filled with spectators.",
      C: "The net divides the court into two sections.",
      D: "Lines are being drawn on the court.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 네트가 코트를 두 구역으로 나누고 있음\n" +
      "오답 설명: (A) 테니스 경기가 진행되지 않음, (B) 관중석에 사람이 없음, (D) 라인은 이미 그려져 있음",
  },

  {
    questionNumber: 7,
    choices: {
      A: "A bowling ball is being thrown.",
      B: "Several bowling balls have been placed on a rack.",
      C: "All the pins have been knocked down.",
      D: "The bowling lanes are being polished.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여러 개의 볼링공이 랙에 놓여있음\n" +
      "오답 설명: (A) 볼링공이 던져지지 않고 가만히 있음, (C) 핀들이 쓰러지지 않고 서있음, (D) 레인이 닦이는 중이 아님",
  },

  {
    questionNumber: 8,
    choices: {
      A: "Skiers are riding the chairlifts.",
      B: "The slopes are crowded with skiers.",
      C: "Chairlifts are suspended from cables.",
      D: "A skier is coming down the slope.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 리프트가 케이블에 매달려 있음\n" +
      "오답 설명: (A) 리프트에 탑승한 사람이 없음, (B) 슬로프에 스키 타는 사람이 없음, (D) 슬로프를 내려오는 스키어가 없음",
  },
  {
    questionNumber: 9,
    choices: {
      A: "A table tennis paddle is resting on the table.",
      B: "A bicycle is hung on the wall.",
      C: "A dining table is set with plates and glasses.",
      D: "The garage door has been opened.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 탁구 라켓이 테이블 위에 놓여있음\n" +
      "오답 설명: (B) 자전거는 벽에 걸려있지 않고 기대어 있음, (C) 테이블에 접시나 유리잔이 없음, (D) 차고 문이 닫혀있음",
  },
  {
    questionNumber: 10,
    choices: {
      A: "Some paintings are being hung on the walls.",
      B: "A bench has been placed in the middle of the gallery.",
      C: "The floor has been covered with a carpet.",
      D: "Artworks have been mounted on the walls.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 예술 작품들이 벽에 걸려있음\n" +
      "오답 설명: (A) 그림은 이미 걸려있는 상태임, (B) 갤러리 중앙에 벤치가 없음, (C) 바닥에 카펫이 깔려있지 않음",
  },
  {
    questionNumber: 11,
    choices: {
      A: "Some artifacts are being restored.",
      B: "A glass case has been removed from the exhibition.",
      C: "A visitor is observing the display.",
      D: "Historical artifacts have been arranged in display cases.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 역사적 유물들이 진열장에 전시되어 있음\n" +
      "오답 설명: (A) 유물 복원 작업이 진행되지 않음, (B) 진열장이 제거되지 않음, (C) 관람객이 보이지 않음",
  },
  {
    questionNumber: 12,
    choices: {
      A: "A performance is being held on the stage.",
      B: "The seats are being filled with an audience.",
      C: "The seats have been arranged in rows.",
      D: "The curtains are being drawn to close the stage.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 좌석이 열을 지어 배치되어 있음\n" +
      "오답 설명: (A) 무대에서 공연이 진행되지 않음, (B) 관객이 없음, (D) 커튼이 닫히지 않음",
  },
];
